<template>
  <v-list exact>
    <MainMenuItem icon="mdi-home-outline" :title="$t('app.home')" link="AppStart" />

    <template v-if="!$auth.loading">
      <template v-if="!$auth.isAuthenticated">
        <!-- Logged out only items here -->
        <v-list-item link exact :to="{name: 'AppDocuments'}">
          <v-list-item-action>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-1">{{ $t('app.rightsholder-forms') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item exact link :to="{name: 'AppLogin'}">
          <v-list-item-action>
            <v-icon>mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-1">{{ $t('app.login') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-if="$auth.isAuthenticated">
        <!-- Logged in only items here -->

        <MainMenuItem
          icon="mdi-file-document-outline"
          link="AppDocuments"
          :title="$t('menu.docs')"
        />
        <MainMenuItem
          v-if="currentRightsholderId"
          icon="mdi-account-box-multiple-outline"
          link="Rightsholders"
          :title="$t('menu.rightsholders')"
        />
        <MainMenuItem
          v-if="currentRightsholderId"
          icon="mdi-trending-up"
          link="Statements"
          :title="$t('menu.statements')"
        />

        <v-list-group
          v-if="currentRightsholderId"
          prepend-icon="mdi-folder-open-outline"
          :value="['CurrentRights', 'CurrentRightsActionRequired', 'CurrentRightsDoubleClaims', 'UnclaimedRights', 'StagingArea', 'ClaimForms', 'UploadedFiles'].includes($route.name)">
          <template v-slot:activator>
            <v-list-item-title>{{ $t('menu.rights') }}</v-list-item-title>
          </template>

          <MainMenuItem
            icon="mdi-file-music-outline"
            link="CurrentRights"
            :title="$t('menu.currentRights')"
            :exact="false"
          />
          <MainMenuItem
            icon="mdi-file-document-multiple-outline"
            link="UnclaimedRights"
            :title="$t('menu.unclaimedRights')"
          />
          <MainMenuItem
              icon="mdi-dots-grid"
              link="StagingArea"
              :title="$t('menu.staging')"
          />
          <MainMenuItem
              icon="mdi-note-plus-outline"
              link="ClaimForms"
              :title="$t('menu.claimforms')"
          />
          <MainMenuItem
              icon="mdi-file-star-four-points-outline"
              link="UploadedFiles"
              :title="$t('uploads.pageTitle')"
          />
        </v-list-group>

        <MainMenuItem @click="$emit('open-consent-dialog')" icon="mdi-cookie-cog-outline" :title="$t('cookie.menu-item')" />
        <MainMenuItem @click="logout" icon="mdi-logout" :title="$t('app.logout')" />
      </template>
    </template>
  </v-list>
</template>

<script>
import {mapGetters} from "vuex";
import MainMenuItem from "@/components/common/MainMenuItem.vue";

export default {
  name: "MainMenu",

  components: {
    MainMenuItem,
  },

  computed: {
    ...mapGetters('app', ['currentRightsholder']),

    currentRightsholderId() {
      return this.currentRightsholder.id;
    }

  },

  methods: {
    async logout() {
      const res = await this.$dialog.confirm({
        text: this.$t("app.logout-confirm"),
        title: this.$t("app.logout"),
      });
      if (res) {
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      }
    },
  },
};
</script>

<style>
</style>
